import React from 'react';
import Component from '@vfuk/core-color-picker';
const ColorPicker = props => {
    return React.createElement(Component, Object.assign({}, props));
};
export default ColorPicker;
